export default __webpack_public_path__ + "static/media/02.7ab0b8a1.jpg";